<template>
    <div class="flex flex-col dark:text-white">
        <h1 class="mt-4 text-2xl font-bold">Solicitações de Troca de E-mail</h1>
        <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
            Solicitações enviadas pelos produtores via Phoenix que precisam de validação manual do atendimento.
        </p>

        <filters
            v-model="filters"
            @fetch="fetch"
            :loading="loading"
            search-filter
            search-label="Filtrar por e-mail (atual ou novo)"
            status-filter
            :statuses="statuses"
            :default-status="defaultStatus"
            date-filter
            class="mt-4"
        />

        <div class="mt-6">
        <table-component
            :loading="loading"
            :pagination="pagination"
            :headers="headers"
            @fetch="fetch"
        >
            <tr v-for="r in requests" :key="r.id">
                <td class="table-cell-sm">#{{ r.id }}</td>
                <td class="table-cell-sm">
                    <span :class="statusBadgeClass(r.status)" class="rounded px-2 py-1 text-xs">
                        {{ statusLabel(r.status) }}
                    </span>
                </td>
                <td class="table-cell-sm">{{ r.source_email }}</td>
                <td class="table-cell-sm">{{ r.target_email }}</td>
                <td class="table-cell-sm">
                    <span v-if="r.needs_support" class="rounded bg-orange-100 px-2 py-1 text-xs text-orange-700">Suporte</span>
                    <span v-else class="rounded bg-blue-100 px-2 py-1 text-xs text-blue-700">Self-service</span>
                </td>
                <td class="table-cell-sm">{{ r.created_at }}</td>
                <td class="table-cell-sm">
                    <router-link
                        :to="{ name: 'producer-email-change-request.detail', params: { request_id: r.id } }"
                        class="text-indigo-500 hover:underline"
                    >
                        Ver detalhes
                    </router-link>
                </td>
            </tr>
        </table-component>
        </div>
    </div>
</template>

<script>
import Filters from "../../components/layouts/Filters.vue";
import TableComponent from "../../components/layouts/table/TableComponent.vue";

const STATUS_LABELS = {
    pending_user_confirmation: "Aguardando cliente",
    pending_support: "Aguardando atendimento",
    confirmed: "Confirmada",
    processed: "Processada",
    rejected: "Rejeitada",
    expired: "Expirada",
};

const STATUS_CLASSES = {
    pending_user_confirmation: "bg-yellow-100 text-yellow-700",
    pending_support: "bg-orange-100 text-orange-700",
    confirmed: "bg-blue-100 text-blue-700",
    processed: "bg-green-100 text-green-700",
    rejected: "bg-red-100 text-red-700",
    expired: "bg-gray-100 text-gray-700",
};

export default {
    components: { Filters, TableComponent },
    data() {
        return {
            pagination: {
                total: 0,
                per_page: 10,
                current_page: 1,
                last_page: 1,
                from: 1,
                to: 10,
            },
            filters: { text: "", status: ["pending_support", "pending_user_confirmation"] },
            loading: false,
            requests: [],
            headers: ["ID", "Status", "E-mail atual", "Novo e-mail", "Tipo", "Data", "Ações"],
            defaultStatus: ["pending_support", "pending_user_confirmation"],
            statuses: [
                { value: "pending_support", label: "Aguardando atendimento" },
                { value: "pending_user_confirmation", label: "Aguardando cliente" },
                { value: "confirmed", label: "Confirmada" },
                { value: "processed", label: "Processada" },
                { value: "rejected", label: "Rejeitada" },
                { value: "expired", label: "Expirada" },
            ],
        };
    },
    watch: {
        filters: {
            handler() {
                this.pagination.current_page = 1;
                this.fetch();
            },
            deep: true,
        },
    },
    methods: {
        fetch() {
            this.loading = true;
            const params = {
                ...this.filters,
                page: this.pagination.current_page,
                per_page: this.pagination.per_page,
            };
            axios
                .get("/api/producer-email-change-requests", { params })
                .then(({ data }) => {
                    this.requests = data.data;
                    this.pagination = data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        statusLabel(status) {
            return STATUS_LABELS[status] ?? status;
        },
        statusBadgeClass(status) {
            return STATUS_CLASSES[status] ?? "bg-gray-100 text-gray-700";
        },
    },
};
</script>
